import React from "react";
import { TouchableOpacity, Text } from "react-native";
import Ionicons from "react-native-vector-icons/Ionicons";

interface TipsToggleButtonProps {
  tipsEnabled: boolean;
  onToggle: () => void;
}

/**
 * Toggle button for onboarding tips
 */
export const TipsToggleButton: React.FC<TipsToggleButtonProps> = ({
  tipsEnabled,
  onToggle,
}) => {
  return (
    <TouchableOpacity
      onPress={onToggle}
      style={{ flexDirection: "row", alignItems: "center", padding: 6 }}
    >
      <Ionicons
        name="information-circle-outline"
        size={18}
        color="#00B7F4"
        style={{ marginRight: 6 }}
      />
      <Text style={{ fontWeight: "500", color: "#00B7F4" }}>
        {tipsEnabled ? "Hide tips" : "Tips"}
      </Text>
    </TouchableOpacity>
  );
};
